(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dog-formula-request"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('dogFormulaForm');
    const successMessage = document.getElementById('successMessage');

    // Validation rules
    const validationRules = {
      name: {
        required: true,
        validate: (value) => value.trim().length >= 2,
        message: 'Please enter a valid name (at least 2 characters)'
      },
      email: {
        required: true,
        validate: (value) => {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value);
        },
        message: 'Please enter a valid email address'
      },
      dog: {
        required: true,
        validate: (value) => value.trim().length >= 1,
        message: 'Please enter your dog\'s name'
      },
      weight: {
        required: true,
        validate: (value) => {
          const num = parseFloat(value);
          return !isNaN(num) && num > 0 && num <= 300;
        },
        message: 'Please enter a valid weight (0-300 lbs)'
      },
      brief: {
        required: true,
        validate: (value) => value.trim().length >= 10,
        message: 'Please provide at least 10 characters describing your dog\'s needs'
      }
    };

    // Clear error messages on input
    Object.keys(validationRules).forEach(fieldName => {
      const field = form.elements[fieldName];
      if (field) {
        field.addEventListener('input', function() {
          const errorElement = document.getElementById(fieldName + 'Error');
          if (errorElement) {
            errorElement.classList.remove('show');
          }
        });
      }
    });

    // Form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Reset success message
      successMessage.classList.remove('show');

      // Validate form
      let isValid = true;
      const errors = {};

      Object.keys(validationRules).forEach(fieldName => {
        const field = form.elements[fieldName];
        if (field) {
          const rule = validationRules[fieldName];
          const value = field.value;

          if (rule.required && !value.trim()) {
            isValid = false;
            errors[fieldName] = 'This field is required';
          } else if (value.trim() && !rule.validate(value)) {
            isValid = false;
            errors[fieldName] = rule.message;
          }
        }
      });

      // Display errors
      Object.keys(errors).forEach(fieldName => {
        const errorElement = document.getElementById(fieldName + 'Error');
        if (errorElement) {
          errorElement.textContent = errors[fieldName];
          errorElement.classList.add('show');
        }
      });

      // If valid, submit
      if (isValid) {
        submitFormData();
      }
    });

    // Form submission handler
    function submitFormData() {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData);

      // Send to Shopify or your backend
      fetch(window.location.pathname, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          // Show success message
          successMessage.classList.add('show');
          
          // Reset form
          form.reset();
          
          // Scroll to success message
          successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          
          // Hide success message after 5 seconds
          setTimeout(() => {
            successMessage.classList.remove('show');
          }, 5000);
        } else {
          alert('An error occurred. Please try again.');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('An error occurred. Please try again.');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
